import { Model } from "@vuex-orm/core";
import config from "../configs/MeetingGuest";
import Meeting from "./Meeting";
export default class MeetingGuest extends Model {
  static get entity() {
    return "meeting_guests";
  }
  static fields() {
    return {
      id: this.attr(null),
      username: this.attr(null),
      password: this.attr(null),
      agency_id: this.attr(null),
      user_id: this.attr(null),
      fullname: this.attr(null),
      email: this.attr(null),
      meeting_id: this.attr(null),
      meeting: this.belongsTo(Meeting, "meeting_id"),
      access_status: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
